import React from 'react'
import SettingsMetaData from '../../../../Components/Hooks/useSettingsMetaData';

function Designation() {
   return (
    <SettingsMetaData propertyName={"Designation_Team"} viewPropertyName={"Designation"} />
  );
}

export default Designation